import {
  ConfigurationPanel,
  ConfigurationPanelHeader,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
} from "V2.0/HomePages/PipelinesV2/PipelineBuilderV2/Components/ConfigurationPanel";
import {
  NodeExecutionName,
  NodeExecutionOutputPort,
  NodeExecutionDataPreview,
  NodeExecutionStatus,
  NodeExecutionTiming,
  NodeExecutionAction,
} from "../../Components/NodeExecutionPreview";

export default DelayExecution;

function DelayExecution(props) {
  const { node, nodeExecution, closePanel } = props;

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <NodeExecutionName name={node?.data?.name} />
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        <div className="space-y-4">
          <NodeExecutionStatus status={nodeExecution.status} />
          <NodeExecutionTiming
            label={"Start Time:"}
            timestamp={nodeExecution?.startTime}
          />
          <NodeExecutionTiming
            label={"End Time:"}
            timestamp={nodeExecution?.endTime}
          />
          <NodeExecutionOutputPort outputPort={nodeExecution?.outputPort} />
          <NodeExecutionDataPreview
            title="Input"
            data={nodeExecution.input}
          />
          <NodeExecutionDataPreview
            title="Output"
            data={nodeExecution.output}
          />
        </div>
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <NodeExecutionAction onClose={closePanel} />
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
